import React, { Component, Fragment } from 'react'
import { Tabs, TabList, TabPanel, Tab } from 'react-tabs';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getUserInfo,clearUserDetails } from "../../../actions/user"
import {updateUserInfo as updateUser}  from "../../../actions/user"
import { updateUserInfo } from "../../../actions/updUserInfo";
import SimpleReactValidator from 'simple-react-validator';
// import Select from 'react-dropdown-select';
import { withRouter } from 'react-router-dom';

import {getGenderFilters} from '../../../actions/filters';

var loading = <img src={require('../../../assets/images/loader.gif')} width={20} height={20} alt="" />;

class UserDetailInfo extends Component {
    constructor() {
        super()
        this.state = {
            cons_first_name: "",
            cons_last_name: "",
            cons_email_id: "",
            cons_dob: "",
            cons_gender: "",
        }
        this.validator = new SimpleReactValidator();
    }

    componentDidMount() {
        
        this.setState({
            cons_first_name: this.props.userDetails.COM_FNAME,
            cons_last_name: this.props.userDetails.COM_LNAME,
            cons_email_id:  this.props.userDetails.COM_EMAIL_ID,
            cons_dob: this.props.userDetails.COM_DOB,
        })
    }
 

    handleBack = () => {
        this.props.history.goBack()
        this.props.history.goBack()
        if(localStorage.getItem('lot_code')) {
        this.props.history.push('/PD/'+localStorage.getItem('lot_code'));
        localStorage.removeItem('lot_code')

        } else {
            this.props.history.push('csa-home')  ;
        }
    }

    handleChange(event) {
        this.setState({ [event.target.id]: event.target.value });
    }

     handleRemove(){
         this.props.clearUserDetails();
         localStorage.removeItem('mobile_no')
         this.props.history.push('/update')
     }

    async handleSubmit(event) {
        event.preventDefault();
        if (this.validator.allValid()) {
            const { connection_id } = this.props
            const options = {
                connection_id,
                user_data: {
                    ...this.state,
                    cons_mobile_no: localStorage.getItem('newRegNumber') !== null ? localStorage.getItem('newRegNumber') : this.props.userDetails &&  this.props.userDetails.COM_CONSUMER_MOBILE_NO
                }
            }
            const user = {
                connection_id,
                mobile_no: localStorage.getItem('newRegNumber') !== null ? localStorage.getItem('newRegNumber') : this.props.userDetails && this.props.userDetails.COM_CONSUMER_MOBILE_NO
            }
        let res =   await  this.props.updateUserInfo(options)

            this.props.updateUser(user)
            setTimeout(() => {
                if(localStorage.getItem('lot_code')) {
                    this.props.history.push('/PD/'+localStorage.getItem('lot_code'));
                    localStorage.removeItem('lot_code')
                    } else {
                this.props.history.push('csa-home')
                    }
            }, 3000)
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    
   

    render() {
        
        // const {genderFilter} = this.props
        return (
            <Fragment>
                <section className="tab-product m-0">
                <div className="container" style={{ marginTop: 40, marginBottom: 40 }}>
                        <div className="row justify-content-center">
                            <div className="col-sm-12 col-lg-6">
                                <Tabs className="tab-content nav-material" style={{padding:15}}>
                                    <TabList className="nav nav-tabs nav-material">
                                    <Tab className="nav-item" style={{ width: "100%" }}>
                                            <span className="nav-link" style={{fontSize:18,fontWeight:'bold'}}>
                                                <i className="icofont icofont-contacts"></i>Update Consumer Details</span>
                                            <div className="material-border" ></div>
                                        </Tab>
                                    </TabList>
                                    <TabPanel>
                                        <form className="theme-form mt-4" onSubmit={(e) => this.handleSubmit(e)}>
                                            <div className="form-row">
                                                <div className="col-md-12">
                                                    <label htmlFor="name">First Name</label>
                                                    <input className="form-control" type="text" id="cons_first_name"
                                                   defaultValue={this.props.userDetails.COM_FNAME}      onChange={(e) => this.handleChange(e)} autocomplete="new"/>
                                                    {this.validator.message('first name', this.state.cons_first_name, 'required|alpha_space')}
                                                </div>
                                                <div className="col-md-12">
                                                    <label htmlFor="email">Last Name</label>
                                                    <input className="form-control" type="text" id="cons_last_name"
                                                   defaultValue={this.props.userDetails.COM_LNAME}      onChange={(e) => this.handleChange(e)} autocomplete="new"/>
                                                    {/* {this.validator.message('last name', this.state.cons_last_name, 'required|alpha')} */}
                                                </div>
                                                <div className="col-md-12">
                                                    <label htmlFor="review">Email</label>
                                                    <input className="form-control" type="text" id="cons_email_id"
                                                        defaultValue={this.props.userDetails.COM_EMAIL_ID} onChange={(e) => this.handleChange(e)} autocomplete="new"/>
                                                    {this.validator.message('email', this.state.cons_email_id, 'required|email')}
                                                </div>
                                                <div className="col-md-12">
                                                    <label htmlFor="review">Mobile No</label>
                                                    <input className="form-control" type="text" id="cons_mobile_no"
                                                        value={localStorage.getItem('newRegNumber') !== null ? localStorage.getItem('newRegNumber') : this.props.userDetails.COM_CONSUMER_MOBILE_NO } readOnly />
                                                </div>
                                               
                                                <div className="col-md-6">
                                                    {/* <label htmlFor="review">Gender</label> */}
                                                    {/* <input className="form-control" type="text" id="cons_gender"
                                                        value={this.props.userDetails.COM_GENDER_DESC} readOnly /> */}
                                                        {/* <select className="form-control" id="cons_gender">
                                                             <option value={'ME'}>Men</option>
                                                             <option value={'Wo'}>Women</option>
                                                        </select> */}
                                                        {/* <Select
                                                            loading={genderFilter.loading}
                                                            searchable={false}
                                                            labelField='GEN_GENDER_NAME'
                                                            valueField='GEN_GENDER_CD'
                                                            keepSelectedInList={false}
                                                            options={genderFilter.data}
                                                           placeholder={this.props.userDetails.COM_GENDER_DESC || ''}
                                                            values={[]}
                                                            onChange={(values) => this.handleGenderChange(values)}
                                                        /> */}
                                                </div>
                                                <div className="col-md-12" style={{paddingBottom:100}} >
                                                    <div className="pull-right">
                                                        <button type="button" className="btn btn-solid" style={{ marginRight: 10 }}
                                                            onClick={() => this.handleBack()}
                                                        >Back</button>
                                                        <button type="submit" className="btn btn-solid" disabled={this.props.updatingUser}>{this.props.updatingUser ? loading : 'Save'}</button>
                                                        &nbsp; &nbsp;
                                                        <button className="btn btn-solid" onClick={()=>this.handleRemove()}> Reset </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </TabPanel>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    isAuth: state.user.isAuth,
    userDetails: state.user.user_details || [],
    connection_id: state.tenant.connection_id,
    updatingUser: state.updateUser.loading,
    // genderFilter: state.filters.gender
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { getUserInfo, updateUserInfo,updateUser, getGenderFilters ,clearUserDetails},
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(UserDetailInfo));
